/*
  shorthand functions for common queries
*/

import {
  CHANGE_QUESTIONS,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { requiresNetworkItSecurityApprovalId, customerImpactingId } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-constants';
import {
  getFieldValueForParameters,
} from './common-logic';


const getPreImp6Value = (formData) => getFieldValueForParameters({
  formData,
  sectionId: CHANGE_QUESTIONS,
  fieldId: requiresNetworkItSecurityApprovalId,
});

const getPreImp2Value = (formData) => getFieldValueForParameters({
  formData,
  sectionId: CHANGE_QUESTIONS,
  fieldId: customerImpactingId,
});



export {
  getPreImp6Value,
  getPreImp2Value,
};

